module.exports = __webpack_public_path__ + "static/media/discount-svgrepo-com.2ba32b44.png";